import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import useOnScreen from '../../../hooks/useOnScreen';
import './styles.css';

const RatingAverage = ({ reviewRatings }) => {
  const [viewed, setViewed] = useState(false);
  const ref = useRef();
  const onScreen = useOnScreen(ref);

  useEffect(() => {
    if (onScreen) setViewed(true);
  }, [onScreen]);

  return (
    <div
      className={classNames('RatingAverage__root', {
        'RatingAverage__root--onScreen': viewed,
      })}
      ref={ref}
    >
      {reviewRatings.map(({ percentage, rating }) => (
        <div className="RatingAverage__item" key={rating}>
          <div className="RatingAverage__name">{rating} stars</div>
          <div className="RatingAverage__bar">
            <span
              className="RatingAverage__barLine"
              style={{ width: percentage }}
            />
          </div>
          <div className="RatingAverage__percentage">{percentage}</div>
        </div>
      ))}
    </div>
  );
};

export default RatingAverage;
